import './scss/static/borgata.css';
import './scss/static/bwin.css';
import './scss/static/mgm.css';
import cssVars from 'css-vars-ponyfill';
import Vue from 'vue';
import store from './store';
import App from './App.vue';

import './scss/main.scss';

cssVars({
  include: '[data-cssvarsponyfill="true"]',
  onlyVars: true
});

Vue.config.productionTip = false;

new Vue({
  store,
  render: h => h(App)
}).$mount('#promo-app');
